import styled from 'styled-components';

const RangeInput = styled.input(({ theme }) => {
  const { color } = theme;

  return `
    -webkit-appearance: none;
    width: 100%;
    background: transparent;
    cursor: pointer;
    position: relative;
    z-index: 1;
    overflow: hidden;
    border-radius: 50px;
    margin: 0;
    height: 16px;

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      height: 8px;
      width: 8px;
      border-radius: 50%;
      background-color: ${color.grayscale[1000]};
      border: 4px solid ${color.tertiary.regular};
      box-sizing: content-box;
      z-index: 2;
    }

    &::-moz-range-thumb {
      -webkit-appearance: none;
      height: 8px;
      width: 8px;
      border-radius: 50%;
      background-color: ${color.grayscale[1000]};
      border: 4px solid ${color.tertiary.regular};
      box-sizing: content-box;
      z-index: 2;
    }

    &::-webkit-slider-runnable-track {
      width: 100%;
      height: 16px;
      background-color: ${color.grayscale[800]};
      border-radius: 50px;
    }

    &::-moz-range-track {
      width: 100%;
      height: 16px;
      background-color: ${color.grayscale[800]};
      border-radius: 50px;
    }
    
    &:focus:focus-visible {
      &::-webkit-slider-runnable-track {
        outline: 2px auto -webkit-focus-ring-color;
      }

      &::-moz-range-track {
        outline: 2px auto -webkit-focus-ring-color;
      }
    }

    &:focus-within:focus-visible {
      outline: none;
      
      &::-webkit-slider-thumb {
        outline: 2px solid ${color.grayscale[1000]};
      }

      &::-moz-range-thumb {
        outline: 2px solid ${color.grayscale[1000]};
      }
    }

    &.backfill {
      &::-moz-range-progress {
        height: 16px;
        background-color: ${color.tertiary.regular};
      }

      &::-webkit-slider-thumb {
        box-shadow: -510px 0 0 500px ${color.tertiary.regular};
      }
    }

    &:disabled {
      cursor: default;

      &::-webkit-slider-thumb {
        border: 4px solid ${color.grayscale[600]};
      }

      &::-moz-range-thumb {
        border: 4px solid ${color.grayscale[600]};
      }

      &.backfill {
        &::-moz-range-progress {
          height: 16px;
          background-color: ${color.grayscale[600]};
        }

        &::-webkit-slider-thumb {
          box-shadow: -510px 0 0 500px ${color.grayscale[600]};
        }
      }
    }
  `;
});

const Range = ({ name, value, min, max, step, showBackfill, disabled, handleInput }) => {
  return (
    <RangeInput
      name={name}
      id={name}
      defaultValue={value}
      type="range"
      min={min}
      max={max}
      step={step}
      onInput={handleInput}
      className={showBackfill ? 'backfill' : ''}
      disabled={disabled}
    />
  );
};

export default Range;
